import { render } from "./headmasterStudioState.vue?vue&type=template&id=5566c027&scoped=true"
import script from "./headmasterStudioState.vue?vue&type=script&lang=js"
export * from "./headmasterStudioState.vue?vue&type=script&lang=js"

import "./headmasterStudioState.vue?vue&type=style&index=0&id=5566c027&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5566c027"]])

export default __exports__